import HttpError from "../../utils/http/http.error";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import OrderCancelOrderParams from "./cancel/order/order-cancel-order-params";
import OrderCancelOrderRequest from "../../api/raily/order/cancel/order/order-cancel-order.request";
import orderCancelOrderParamsFactory from "./cancel/order/order-cancel-order-params.factory";
import orderApiService from "../../api/raily/order/order-api.service";
import {
  OrderCancelOrderNotAcceptableResponse,
  OrderCancelOrderNotAcceptableResponseErrorType,
} from "../../api/raily/order/cancel/order/order-cancel-order.response";
import OrderCancelOrderError from "./cancel/order/order-cancel-order-error";
import {
  OrderCancelRequestNotAcceptableResponse,
  OrderCancelRequestNotAcceptableResponseErrorType,
} from "../../api/raily/order/cancel/request/order-cancel-request.response";
import OrderCancelOrderErrorFactory from "./cancel/order/order-cancel-order-error.factory";
import OrderCancelRequestParams from "./cancel/request/order-cancel-request-params";
import OrderCancelRequestRequest from "../../api/raily/order/cancel/request/order-cancel-request.request";
import orderCancelRequestParamsFactory from "./cancel/request/order-cancel-request-params.factory";
import OrderCancelRequestError from "./cancel/request/order-cancel-request-error";
import OrderCancelRequestErrorFactory from "./cancel/request/order-cancel-request-error.factory";
import {
  OrderCancelRevertRequestNotAcceptableResponse,
  OrderCancelRevertRequestNotAcceptableResponseErrorType,
} from "../../api/raily/order/cancel/revert-request/order-cancel-revert-request.response";
import OrderCancelRevertRequestError from "./cancel/revert-request/order-cancel-revert-request-error";
import orderCancelRevertRequestErrorFactory from "./cancel/revert-request/order-cancel-revert-request-error.factory";
import OrderCancelRevertRequestParams from "./cancel/revert-request/order-cancel-revert-request-params";
import OrderCancelRevertRequestRequest from "../../api/raily/order/cancel/revert-request/order-cancel-revert-request.request";
import orderCancelRevertRequestParamsFactory from "./cancel/revert-request/order-cancel-revert-request-params.factory";
import OrderUpdateError from "./update/order-update-error";
import OrderUpdateParams from "./update/order-update-params";
import OrderUpdateRequest from "../../api/raily/order/update/order-update.request";
import orderUpdateParamsFactory from "./update/order-update-params.factory";
import {
  OrderUpdateErrorType,
  OrderUpdateNotAcceptableResponse,
  OrderUpdateUnprocessableEntityErrorType,
  OrderUpdateUnprocessableEntityResponse,
} from "../../api/raily/order/update/order-update.response";
import orderUpdateErrorFactory from "./update/order-update-error.factory";
import OrderAttentionApprovalParams from "./attention-approval/order-attention-approval-params";
import OrderAttentionApprovalRequest from "../../api/raily/order/attention-approval/order-attention-approval.request";
import orderAttentionApprovalParamsFactory from "./attention-approval/order-attention-approval-params.factory";
import OrderAttentionApprovalError from "./attention-approval/order-attention-approval-error";
import OrderAddParams from "./add/order-add-params";
import orderAddParamsFactory from "./add/order-add-params.factory";
import OrderAddError from "./add/order-add-error";
import orderAddErrorFactory from "./add/order-add-error.factory";
import {
  OrderAddNotAcceptableResponse,
  OrderAddResponseSuccessResponse,
  OrderAddUnprocessableEntityResponse,
} from "../../api/raily/order/add/order-add-response";
import OrderChangeTaxiError from "./change-taxi/order-change-taxi-error";
import OrderChangeTaxiParams from "./change-taxi/order-change-taxi-params";
import OrderChangeTaxiRequest from "../../api/raily/order/change-taxi/order-change-taxi.request";
import orderChangeTaxiParamsFactory from "./change-taxi/order-change-taxi-params.factory";
import OrderExternalIdUpdateParams from "./external-id-update/order-external-id-update-params";
import orderExternalIdUpdateParamsFactory from "./external-id-update/order-external-id-update-params.factory";
import OrderExternalIdUpdateError from "./external-id-update/order-external-id-update-error";
import {
  OrderJoinNotAcceptableResponse,
  OrderJoinSuccessResponse,
} from "../../api/raily/order/join/order-join.response";
import OrderJoinError, {
  OrderJoinChangeTargetRideErrorType,
  OrderJoinErrorType,
} from "./join/order-join-error";
import OrderJoinParams from "./join/order-join-params";
import OrderJoinRequest from "../../api/raily/order/join/order-join.request";
import orderJoinParamsFactory from "./join/order-join-params.factory";
import orderJoinErrorFactory from "./join/order-join-error.factory";
import orderJoinFactory from "./join/order-join.factory";
import OrderJoin from "./join/order-join";
import OrderFinishedCargoOrdersCountParams from "./finished-cargo-orders/count/order-finished-cargo-orders-count-params";
import OrderFinishedCargoOrdersCountError from "./finished-cargo-orders/count/order-finished-cargo-orders-count-error";
import orderFinishedCargoOrdersCountParamsFactory from "./finished-cargo-orders/count/order-finished-cargo-orders-count-params.factory";
import OrderFinishedCargoOrdersUnbilledListError from "./finished-cargo-orders/unbilled-list/order-finished-cargo-orders-unbilled-list-error";
import OrderFinishedCargoOrdersUnbilledListParams from "./finished-cargo-orders/unbilled-list/order-finished-cargo-orders-unbilled-list-params";
import OrderFinishedCargoOrdersUnbilledList from "./finished-cargo-orders/unbilled-list/order-finished-cargo-orders-unbilled-list";
import orderFinishedCargoOrdersUnbilledListParamsFactory from "./finished-cargo-orders/unbilled-list/order-finished-cargo-orders-unbilled-list-params.factory";
import orderFinishedCargoOrdersUnbilledListFactory from "./finished-cargo-orders/unbilled-list/order-finished-cargo-orders-unbilled-list.factory";
import {
  OrderTransportingOrderForwardingDeleteNotAcceptableResponse,
  OrderTransportingOrderForwardingDeleteNotAcceptableResponseErrorType,
} from "../../api/raily/order/transporting-order/forwarding/delete/order-transporting-order-forwarding-delete.response";
import OrderTransportingOrderForwardingListRequest from "../../api/raily/order/transporting-order/forwarding/list/order-transporting-order-forwarding-list.request";
import OrderTransportingOrderForwardingSendRequest from "../../api/raily/order/transporting-order/forwarding/send/order-transporting-order-forwarding-send.request";
import OrderTransportingOrderAvailableConsumers from "./transporting-order/available-consumers/order-transporting-order-available-consumers";
import OrderTransportingOrderAvailableConsumersError from "./transporting-order/available-consumers/order-transporting-order-available-consumers-error";
import OrderTransportingOrderAvailableConsumersParams from "./transporting-order/available-consumers/order-transporting-order-available-consumers-params";
import orderTransportingOrderAvailableConsumersParamsFactory from "./transporting-order/available-consumers/order-transporting-order-available-consumers-params.factory";
import orderTransportingOrderAvailableConsumersFactory from "./transporting-order/available-consumers/order-transporting-order-available-consumers.factory";
import OrderTransportingOrderAvailableDrivers from "./transporting-order/available-drivers/order-transporting-order-available-drivers";
import OrderTransportingOrderAvailableDriversError from "./transporting-order/available-drivers/order-transporting-order-available-drivers-error";
import OrderTransportingOrderAvailableDriversParams from "./transporting-order/available-drivers/order-transporting-order-available-drivers-params";
import orderTransportingOrderAvailableDriversParamsFactory from "./transporting-order/available-drivers/order-transporting-order-available-drivers-params.factory";
import orderTransportingOrderAvailableDriversFactory from "./transporting-order/available-drivers/order-transporting-order-available-drivers.factory";
import OrderTransportingOrderForwardingDeleteError from "./transporting-order/forwarding/delete/order-transporting-order-forwarding-delete-error";
import orderTransportingOrderForwardingDeleteErrorFactory from "./transporting-order/forwarding/delete/order-transporting-order-forwarding-delete-error.factory";
import OrderTransportingOrderForwardingDeleteParams from "./transporting-order/forwarding/delete/order-transporting-order-forwarding-delete-params";
import orderTransportingOrderForwardingDeleteParamsFactory from "./transporting-order/forwarding/delete/order-transporting-order-forwarding-delete-params.factory";
import OrderTransportingOrderForwardingList from "./transporting-order/forwarding/list/order-transporting-order-forwarding-list";
import OrderTransportingOrderForwardingListError from "./transporting-order/forwarding/list/order-transporting-order-forwarding-list-error";
import OrderTransportingOrderForwardingListParams from "./transporting-order/forwarding/list/order-transporting-order-forwarding-list-params";
import orderTransportingOrderForwardingListParamsFactory from "./transporting-order/forwarding/list/order-transporting-order-forwarding-list-params.factory";
import orderTransportingOrderForwardingListFactory from "./transporting-order/forwarding/list/order-transporting-order-forwarding-list.factory";
import OrderTransportingOrderForwardingSendError from "./transporting-order/forwarding/send/order-transporting-order-forwarding-send-error";
import OrderTransportingOrderForwardingSendParams from "./transporting-order/forwarding/send/order-transporting-order-forwarding-send-params";
import orderTransportingOrderForwardingSendParamsFactory from "./transporting-order/forwarding/send/order-transporting-order-forwarding-send-params.factory";
import OrderCargoOrderAbandonedDownloadError from "./cargo-order/abandoned/download/order-cargo-order-abandoned-download-error";
import OrderCargoOrderAbandonedDownloadParams from "./cargo-order/abandoned/download/order-cargo-order-abandoned-download-params";
import orderCargoOrderAbandonedDownloadParamsFactory from "./cargo-order/abandoned/download/order-cargo-order-abandoned-download-params.factory";
import orderCargoOrderAbandonedDownloadFactory from "./cargo-order/abandoned/download/order-cargo-order-abandoned-download.factory";
import OrderCargoOrderAbandonedListError from "./cargo-order/abandoned/list/order-cargo-order-abandoned-list-error";
import OrderCargoOrderAbandonedListParams from "./cargo-order/abandoned/list/order-cargo-order-abandoned-list-params";
import orderCargoOrderAbandonedListParamsFactory from "./cargo-order/abandoned/list/order-cargo-order-abandoned-list-params.factory";
import orderCargoOrderAbandonedListFactory from "./cargo-order/abandoned/list/order-cargo-order-abandoned-list.factory";
import OrderCargoOrderActiveListError from "./cargo-order/active-list/order-cargo-order-active-list-error";
import OrderCargoOrderActiveListParams from "./cargo-order/active-list/order-cargo-order-active-list-params";
import orderCargoOrderActiveListParamsFactory from "./cargo-order/active-list/order-cargo-order-active-list-params.factory";
import cargoOrderActiveListFactory from "./cargo-order/active-list/order-cargo-order-active-list.factory";
import OrderCargoOrderDetailsComplex from "./cargo-order/details-complex/order-cargo-order-details-complex";
import OrderCargoOrderDetailsComplexError from "./cargo-order/details-complex/order-cargo-order-details-complex-error";
import OrderCargoOrderDetailsComplexParams from "./cargo-order/details-complex/order-cargo-order-details-complex-params";
import orderCargoOrderDetailsComplexParamsFactory from "./cargo-order/details-complex/order-cargo-order-details-complex-params.factory";
import cargoOrderDetailsComplexFactory from "./cargo-order/details-complex/order-cargo-order-details-complex.factory";
import OrderCargoOrderDetails from "./cargo-order/details/order-cargo-order-details";
import OrderCargoOrderDetailsError from "./cargo-order/details/order-cargo-order-details-error";
import OrderCargoOrderDetailsParams from "./cargo-order/details/order-cargo-order-details-params";
import orderCargoOrderDetailsParamsFactory from "./cargo-order/details/order-cargo-order-details-params.factory";
import cargoOrderDetailsFactory from "./cargo-order/details/order-cargo-order-details.factory";
import OrderCargoOrderFinishedDownloadError from "./cargo-order/finished/download/order-cargo-order-finished-download-error";
import OrderCargoOrderFinishedDownloadParams from "./cargo-order/finished/download/order-cargo-order-finished-download-params";
import orderCargoOrderFinishedDownloadParamsFactory from "./cargo-order/finished/download/order-cargo-order-finished-download-params.factory";
import orderCargoOrderFinishedDownloadFactory from "./cargo-order/finished/download/order-cargo-order-finished-download.factory";
import OrderCargoOrderFinishedListParams from "./cargo-order/finished/list/order-cargo-order-finished-list-params";
import OrderCargoOrderDetailsHandlingLogError from "./cargo-order/handling-log/order-cargo-order-details-handling-log-error";
import OrderCargoOrderDetailsHandlingLogParams from "./cargo-order/handling-log/order-cargo-order-details-handling-log-params";
import orderCargoOrderDetailsHandlingLogParamsFactory from "./cargo-order/handling-log/order-cargo-order-details-handling-log-params.factory";
import orderCargoOrderDetailsHandlingLogFactory from "./cargo-order/handling-log/order-cargo-order-details-handling-log.factory";
import OrderCargoOrderHistory from "./cargo-order/history/order-cargo-order-history";
import OrderCargoOrderHistoryParams from "./cargo-order/history/order-cargo-order-history-params";
import orderCargoOrderHistoryParamsFactory from "./cargo-order/history/order-cargo-order-history-params.factory";
import cargoOrderHistoryFactory from "./cargo-order/history/order-cargo-order-history.factory";
import OrderCargoOrderNodeExclusion from "./cargo-order/node-exclusion/order-cargo-order-node-exclusion";
import OrderCargoOrderNodeExclusionError from "./cargo-order/node-exclusion/order-cargo-order-node-exclusion-error";
import OrderCargoOrderNodeExclusionParams from "./cargo-order/node-exclusion/order-cargo-order-node-exclusion-params";
import orderCargoOrderNodeExclusionParamsFactory from "./cargo-order/node-exclusion/order-cargo-order-node-exclusion-params.factory";
import orderCargoOrderNodeExclusionFactory from "./cargo-order/node-exclusion/order-cargo-order-node-exclusion.factory";
import OrderCargoOrderDetailsComplexRequest from "../../api/raily/order/cargo-order/details-complex/order-cargo-order-details-complex.request";
import OrderCargoOrderDetailsRequest from "../../api/raily/order/cargo-order/details/order-cargo-order-details.request";
import OrderCargoOrderActiveListRequest from "../../api/raily/order/cargo-order/active-list/order-cargo-order-active-list.request";
import OrderCargoOrderFinishedListRequest from "../../api/raily/order/cargo-order/finished/list/order-cargo-order-finished-list.request";
import orderCargoOrderFinishedListParamsFactory from "./cargo-order/finished/list/order-cargo-order-finished-list-params.factory";
import orderCargoOrderFinishedListFactory from "./cargo-order/finished/list/order-cargo-order-finished-list.factory";
import OrderCargoOrderFinishedDownloadRequest from "../../api/raily/order/cargo-order/finished/download/order-cargo-order-finished-download-request";
import OrderCargoOrderAbandonedDownloadRequest from "../../api/raily/order/cargo-order/abandoned/download/order-cargo-order-abandoned-download.request";
import OrderCargoOrderDetailsHandlingLogRequest from "../../api/raily/order/cargo-order/handling-log/order-cargo-order-details-handling-log.request";
import OrderCargoOrderHistoryRequest from "../../api/raily/order/cargo-order/history/order-cargo-order-history.request";
import OrderCargoOrderHistoryResponse from "../../api/raily/order/cargo-order/history/order-cargo-order-history.response";
import OrderCargoOrderFinishedListError from "./cargo-order/finished/list/order-cargo-order-finished-list-error";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import OrderCargoOrderDriverSimulation from "./cargo-order/driver-simulation/order-cargo-order-driver-simulation";
import OrderCargoOrderDriverSimulationParams from "./cargo-order/driver-simulation/order-cargo-order-driver-simulation.params";
import orderCargoOrderDriverSimulationParamsFactory from "./cargo-order/driver-simulation/order-cargo-order-driver-simulation-params.factory";
import OrderCargoOrderDriverSimulationError from "./cargo-order/driver-simulation/order-cargo-order-driver-simulation-error";
import orderCargoOrderDriverSimulationFactory from "./cargo-order/driver-simulation/order-cargo-order-driver-simulation.factory";

const createOrderCancelNotAcceptableError = (
  response: OrderCancelOrderNotAcceptableResponse,
): OrderCancelOrderError => {
  switch (response.data.errorType) {
    case OrderCancelOrderNotAcceptableResponseErrorType.ORDER_CANCELLED:
      return OrderCancelOrderErrorFactory.createOrderCancelError();
    case OrderCancelOrderNotAcceptableResponseErrorType.PASSENGER_ON_BOARD:
      return OrderCancelOrderErrorFactory.createPassengerOnBoardError();
    default:
      return dataLoadErrorFactory.createUnexpectedError();
  }
};

const cancel = async (
  params: OrderCancelOrderParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: OrderCancelOrderRequest =
    orderCancelOrderParamsFactory.create(params);

  try {
    const response = await orderApiService().cancel(request, abortSignal);

    if (response.status === 406) {
      throw createOrderCancelNotAcceptableError(
        response as OrderCancelOrderNotAcceptableResponse,
      );
    }

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | OrderCancelOrderError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const createOrderCancelRequestNotAcceptableError = (
  response: OrderCancelRequestNotAcceptableResponse,
): OrderCancelRequestError => {
  switch (response.data.errorType) {
    case OrderCancelRequestNotAcceptableResponseErrorType.ORDER_CANCELLED:
      return OrderCancelRequestErrorFactory.createOrderCancelError();
    case OrderCancelRequestNotAcceptableResponseErrorType.ORDER_CANCEL_REQUESTED:
      return OrderCancelRequestErrorFactory.createOrderCancelRequestError();
    case OrderCancelRequestNotAcceptableResponseErrorType.ORDER_FINISHED:
      return OrderCancelRequestErrorFactory.createOrderFinishedError();
    default:
      return dataLoadErrorFactory.createUnexpectedError();
  }
};

const sendCancelRequest = async (
  params: OrderCancelRequestParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: OrderCancelRequestRequest =
    orderCancelRequestParamsFactory.create(params);

  try {
    const response = await orderApiService().sendCancelRequest(
      request,
      abortSignal,
    );

    if (response.status === 406) {
      throw createOrderCancelRequestNotAcceptableError(
        response as OrderCancelRequestNotAcceptableResponse,
      );
    }

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | OrderCancelRequestError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const createRevertOrderCancelRequestNotAcceptableError = (
  response: OrderCancelRevertRequestNotAcceptableResponse,
): OrderCancelRevertRequestError => {
  switch (response.data.errorType) {
    case OrderCancelRevertRequestNotAcceptableResponseErrorType.ORDER_CANCELLED:
      return orderCancelRevertRequestErrorFactory.createRevertOrderCancelledError();
    case OrderCancelRevertRequestNotAcceptableResponseErrorType.ORDER_CANCEL_NOT_REQUESTED:
      return orderCancelRevertRequestErrorFactory.createRevertOrderCancelNotRequestedError();
    case OrderCancelRevertRequestNotAcceptableResponseErrorType.ORDER_FINISHED:
      return orderCancelRevertRequestErrorFactory.createRevertOrderFinishedError();
    default:
      return dataLoadErrorFactory.createUnexpectedError();
  }
};

const sendRevertCancelRequest = async (
  params: OrderCancelRevertRequestParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: OrderCancelRevertRequestRequest =
    orderCancelRevertRequestParamsFactory.create(params);

  try {
    const response = await orderApiService().sentRevertCancelRequest(
      request,
      abortSignal,
    );

    if (response.status === 406) {
      throw createRevertOrderCancelRequestNotAcceptableError(
        response as OrderCancelRevertRequestNotAcceptableResponse,
      );
    }

    if (response.status !== 204) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | OrderCancelRevertRequestError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const createOrderUpdateErrorsNotAcceptableResponse = (
  response: OrderUpdateNotAcceptableResponse,
): OrderUpdateError => {
  switch (response.data.errorType) {
    case OrderUpdateErrorType.NODE_ALREADY_CHECKED_OUT:
      return orderUpdateErrorFactory.createOrderUpdateNodeAlreadyCheckedOutError();
    case OrderUpdateErrorType.PASSENGERS_DO_OVERLAP:
      return orderUpdateErrorFactory.createOrderUpdatePassengersDoOverlapError();
    case OrderUpdateErrorType.RESULT_TIMING_NOT_POSSIBLE:
      return orderUpdateErrorFactory.createOrderUpdateResultTimingNotPossibleError();
    default:
      return dataLoadErrorFactory.createUnexpectedError();
  }
};

const createOrderUpdateErrorUnprocessableEntityResponse = (
  response: OrderUpdateUnprocessableEntityResponse,
): OrderUpdateError => {
  const [item] = response.data.detail;
  switch (item.errorCode) {
    case OrderUpdateUnprocessableEntityErrorType.TOO_LONG_RIDE:
      return orderUpdateErrorFactory.createOrderUpdateTooLongRideError();
    default:
      return dataLoadErrorFactory.createUnexpectedError();
  }
};

const updateOrder = async (
  params: OrderUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: OrderUpdateRequest = orderUpdateParamsFactory.create(params);

  try {
    const response = await orderApiService().updateOrder(request, abortSignal);

    if (response.status === 406) {
      throw createOrderUpdateErrorsNotAcceptableResponse(
        response as OrderUpdateNotAcceptableResponse,
      );
    }

    if (response.status === 422) {
      throw createOrderUpdateErrorUnprocessableEntityResponse(
        response as OrderUpdateUnprocessableEntityResponse,
      );
    }

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | OrderUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const createOrderJoinErrorsNotAcceptableResponse = (
  response: OrderJoinNotAcceptableResponse,
): OrderJoinError => {
  switch (response.data.errorType) {
    case OrderJoinErrorType.CHANGE_RIDE_RELATED:
      switch (response.data.changeTargetRideError.errorType) {
        case OrderJoinChangeTargetRideErrorType.NODE_ALREADY_CHECKED_OUT:
          return orderJoinErrorFactory.createNodeAlreadyCheckedOutError(); // zlecenie rozpoczęte
        case OrderJoinChangeTargetRideErrorType.NO_VALID_CARGO_RAILY_CONTRACT:
        case OrderJoinChangeTargetRideErrorType.NO_VALID_CARGO_TAXI_CONTRACT:
          return orderJoinErrorFactory.createNoValidContractError(); // brak aktywnego kontraktu
        case OrderJoinChangeTargetRideErrorType.NO_RELEVANT_DISPATCH_FOUND:
          return orderJoinErrorFactory.createNoRelevantDispatchError(); // pasażerowie muszą być częścia obu firm cargo
      }
      break;
    case OrderJoinErrorType.ORDER_ASSIGNED_TO_DRIVER:
      return orderJoinErrorFactory.createOrderAssignedToDriverError(); // kierowca jest już obsadzony do zlecenia
  }
  return orderJoinErrorFactory.createDefaultError(); // nie można połączyć zleceń
};

const getApproveChanges = async (
  params: OrderAttentionApprovalParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: OrderAttentionApprovalRequest =
    orderAttentionApprovalParamsFactory.create(params);

  try {
    const response = await orderApiService().getApproveChanges(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | OrderAttentionApprovalError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const addOrder = async (
  params: OrderAddParams,
  abortSignal: AbortSignal,
): Promise<string> => {
  const request = orderAddParamsFactory.create(params);

  try {
    const response = await orderApiService().addOrder(request, abortSignal);

    if (response.status === 406) {
      throw orderAddErrorFactory.resolveNotAcceptableError(
        response as OrderAddNotAcceptableResponse,
      );
    }

    if (response.status === 422) {
      throw orderAddErrorFactory.resolveUnprocessableEntityError(
        response as OrderAddUnprocessableEntityResponse,
      );
    }

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const successResponse = response as OrderAddResponseSuccessResponse;
    return successResponse.data;
  } catch (_error) {
    const error = _error as HttpError | OrderAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateTaxiCorporation = async (
  params: OrderChangeTaxiParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: OrderChangeTaxiRequest =
    orderChangeTaxiParamsFactory.create(params);

  try {
    const response = await orderApiService().updateTaxiCorporation(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | OrderChangeTaxiError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateExternalId = async (
  params: OrderExternalIdUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = orderExternalIdUpdateParamsFactory.create(params);

  try {
    const response = await orderApiService().externalIdUpdate(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | OrderExternalIdUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const joinOrder = async (
  params: OrderJoinParams,
  abortSignal: AbortSignal,
): Promise<OrderJoin | null> => {
  const request: OrderJoinRequest = orderJoinParamsFactory.create(params);

  try {
    const response = await orderApiService().joinOrder(request, abortSignal);

    if (response.status === 406) {
      throw createOrderJoinErrorsNotAcceptableResponse(
        response as OrderJoinNotAcceptableResponse,
      );
    }

    if (params.dryRun) {
      if (response.status !== 200) {
        throw dataLoadErrorFactory.createUnexpectedError();
      }

      return orderJoinFactory.create(response as OrderJoinSuccessResponse);
    } else {
      if (response.status !== 201) {
        throw dataLoadErrorFactory.createUnexpectedError();
      }
      return null;
    }
  } catch (_error) {
    const error = _error as HttpError | OrderJoinError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getFinishedCargoOrdersCount = async (
  params: OrderFinishedCargoOrdersCountParams,
  abortSignal: AbortSignal,
): Promise<number> => {
  const request = orderFinishedCargoOrdersCountParamsFactory.create(params);

  try {
    const response = await orderApiService().getFinishedCargoOrdersCount(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
    return response.data;
  } catch (_error) {
    const error = _error as HttpError | OrderFinishedCargoOrdersCountError;
    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderFinishedUnbilledList = async (
  params: OrderFinishedCargoOrdersUnbilledListParams,
  abortSignal: AbortSignal,
): Promise<OrderFinishedCargoOrdersUnbilledList> => {
  const request =
    orderFinishedCargoOrdersUnbilledListParamsFactory.create(params);

  try {
    const response = await orderApiService().getUnbilledOrderList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return orderFinishedCargoOrdersUnbilledListFactory.create(response);
  } catch (_error) {
    const error = _error as
      | HttpError
      | OrderFinishedCargoOrdersUnbilledListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const createErrorsFromNotAcceptableResponse = (
  response: OrderTransportingOrderForwardingDeleteNotAcceptableResponse,
): OrderTransportingOrderForwardingDeleteError => {
  switch (response.data.errorType) {
    case OrderTransportingOrderForwardingDeleteNotAcceptableResponseErrorType.ABANDONED_ORDER:
      return orderTransportingOrderForwardingDeleteErrorFactory.createAbandonedOrderError();
    case OrderTransportingOrderForwardingDeleteNotAcceptableResponseErrorType.DRIVER_ASSIGNED:
      return orderTransportingOrderForwardingDeleteErrorFactory.createDriverAssignedError();
    default:
      return dataLoadErrorFactory.createUnexpectedError();
  }
};

const deleteForwarding = async (
  params: OrderTransportingOrderForwardingDeleteParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request =
    orderTransportingOrderForwardingDeleteParamsFactory.create(params);

  try {
    const response = await orderApiService().deleteForwarding(
      request,
      abortSignal,
    );

    if (response.status === 406) {
      throw createErrorsFromNotAcceptableResponse(
        response as OrderTransportingOrderForwardingDeleteNotAcceptableResponse,
      );
    }

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as
      | HttpError
      | OrderTransportingOrderForwardingDeleteError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getTaxiAvailableConsumers = async (
  params: OrderTransportingOrderAvailableConsumersParams,
  abortSignal: AbortSignal,
): Promise<OrderTransportingOrderAvailableConsumers> => {
  const request =
    orderTransportingOrderAvailableConsumersParamsFactory.create(params);

  try {
    const response = await orderApiService().getTaxiAvailableConsumers(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return orderTransportingOrderAvailableConsumersFactory.create(response);
  } catch (_error) {
    const error = _error as
      | HttpError
      | OrderTransportingOrderAvailableConsumersError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const sendForwarding = async (
  params: OrderTransportingOrderForwardingSendParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: OrderTransportingOrderForwardingSendRequest =
    orderTransportingOrderForwardingSendParamsFactory.create(params);

  try {
    const response = await orderApiService().sendForwarding(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as
      | HttpError
      | OrderTransportingOrderForwardingSendError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getForwardingList = async (
  params: OrderTransportingOrderForwardingListParams,
  abortSignal: AbortSignal,
): Promise<OrderTransportingOrderForwardingList> => {
  const request: OrderTransportingOrderForwardingListRequest =
    orderTransportingOrderForwardingListParamsFactory.create(params);

  try {
    const response = await orderApiService().getForwardingList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const transportingOrderFetchForwarding =
      orderTransportingOrderForwardingListFactory.create(response);

    return transportingOrderFetchForwarding;
  } catch (_error) {
    const error = _error as
      | HttpError
      | OrderTransportingOrderForwardingListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getAvailableDrivers = async (
  params: OrderTransportingOrderAvailableDriversParams,
  abortSignal: AbortSignal,
): Promise<OrderTransportingOrderAvailableDrivers> => {
  const request =
    orderTransportingOrderAvailableDriversParamsFactory.create(params);

  try {
    const response = await orderApiService().getAvailableDrivers(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return orderTransportingOrderAvailableDriversFactory.create(response);
  } catch (_error) {
    const error = _error as
      | HttpError
      | OrderTransportingOrderAvailableDriversError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDetailsComplex = async (
  params: OrderCargoOrderDetailsComplexParams,
  abortSignal: AbortSignal,
): Promise<OrderCargoOrderDetailsComplex> => {
  const request: OrderCargoOrderDetailsComplexRequest =
    orderCargoOrderDetailsComplexParamsFactory.create(params);

  try {
    const response = await orderApiService().getCargoOrderDetailsComplex(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return cargoOrderDetailsComplexFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | OrderCargoOrderDetailsComplexError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDetails = async (
  params: OrderCargoOrderDetailsParams,
  abortSignal: AbortSignal,
): Promise<OrderCargoOrderDetails> => {
  const request: OrderCargoOrderDetailsRequest =
    orderCargoOrderDetailsParamsFactory.create(params);

  try {
    const response = await orderApiService().getCargoOrderDetails(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return cargoOrderDetailsFactory.create(response.data);
  } catch (_error) {
    const error = _error as HttpError | OrderCargoOrderDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getActiveList = async (
  params: OrderCargoOrderActiveListParams,
  abortSignal: AbortSignal,
) => {
  const request: OrderCargoOrderActiveListRequest =
    orderCargoOrderActiveListParamsFactory.create(params);

  try {
    const response = await orderApiService().getActiveList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const cargoOrderActiveList = cargoOrderActiveListFactory.create(response);

    return cargoOrderActiveList;
  } catch (_error) {
    const error = _error as HttpError | OrderCargoOrderActiveListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getFinishedList = async (
  params: OrderCargoOrderFinishedListParams,
  abortSignal: AbortSignal,
) => {
  const request: OrderCargoOrderFinishedListRequest =
    orderCargoOrderFinishedListParamsFactory.create(params);

  try {
    const response = await orderApiService().getFinishedList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const cargoOrderFinishedList =
      orderCargoOrderFinishedListFactory.create(response);

    return cargoOrderFinishedList;
  } catch (_error) {
    const error = _error as HttpError | OrderCargoOrderFinishedListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getFinishedDownload = async (
  params: OrderCargoOrderFinishedDownloadParams,
  abortSignal: AbortSignal,
) => {
  const request: OrderCargoOrderFinishedDownloadRequest =
    orderCargoOrderFinishedDownloadParamsFactory.create(params);

  try {
    const response = await orderApiService().getFinishedDownload(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const cargoOrderFinishedListReport =
      orderCargoOrderFinishedDownloadFactory.create(response);

    return cargoOrderFinishedListReport;
  } catch (_error) {
    const error = _error as HttpError | OrderCargoOrderFinishedDownloadError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getAbandonedList = async (
  params: OrderCargoOrderAbandonedListParams,
  abortSignal: AbortSignal,
) => {
  const request = orderCargoOrderAbandonedListParamsFactory.create(params);

  try {
    const response = await orderApiService().getAbandonedCargoOrderList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return orderCargoOrderAbandonedListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | OrderCargoOrderAbandonedListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getAbandonedCargoOrderDownload = async (
  params: OrderCargoOrderAbandonedDownloadParams,
  abortSignal: AbortSignal,
) => {
  const request: OrderCargoOrderAbandonedDownloadRequest =
    orderCargoOrderAbandonedDownloadParamsFactory.create(params);

  try {
    const response = await orderApiService().getAbandonedCargoOrderDownload(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const cargoOrderAbandonedListReport =
      orderCargoOrderAbandonedDownloadFactory.create(response);

    return cargoOrderAbandonedListReport;
  } catch (_error) {
    const error = _error as HttpError | OrderCargoOrderAbandonedDownloadError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getHandlingLog = async (
  params: OrderCargoOrderDetailsHandlingLogParams,
  abortSignal: AbortSignal,
) => {
  const request: OrderCargoOrderDetailsHandlingLogRequest =
    orderCargoOrderDetailsHandlingLogParamsFactory.create(params);

  try {
    const response = await orderApiService().getCargoOrderHandlingLog(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const cargoOrderDetailsHandlingLogData =
      orderCargoOrderDetailsHandlingLogFactory.create(response);

    return cargoOrderDetailsHandlingLogData;
  } catch (_error) {
    const error = _error as HttpError | OrderCargoOrderDetailsHandlingLogError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getCargoOrderHistory = async (
  params: OrderCargoOrderHistoryParams,
  abortSignal: AbortSignal,
): Promise<OrderCargoOrderHistory> => {
  const request: OrderCargoOrderHistoryRequest =
    orderCargoOrderHistoryParamsFactory.create(params);

  try {
    const response: OrderCargoOrderHistoryResponse =
      await orderApiService().getCargoOrderHistory(request, abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const CargoOrderHistory: OrderCargoOrderHistory =
      cargoOrderHistoryFactory.create(response);

    return CargoOrderHistory;
  } catch (_error) {
    const error = _error as HttpError;

    throw handleErrorFactory.handleError(error);
  }
};

const getNodeExclusion = async (
  params: OrderCargoOrderNodeExclusionParams,
  abortSignal: AbortSignal,
): Promise<OrderCargoOrderNodeExclusion> => {
  const request = orderCargoOrderNodeExclusionParamsFactory.create(params);

  try {
    const response = await orderApiService().getCargoOrderNodeExclusion(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return orderCargoOrderNodeExclusionFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | OrderCargoOrderNodeExclusionError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDriverSimulation = async (
  params: OrderCargoOrderDriverSimulationParams,
  abortSignal: AbortSignal,
): Promise<OrderCargoOrderDriverSimulation> => {
  const request = orderCargoOrderDriverSimulationParamsFactory.create(params);

  try {
    const response = await orderApiService().getDriverSimulation(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return orderCargoOrderDriverSimulationFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | OrderCargoOrderDriverSimulationError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const orderService = {
  addOrder,
  cancel,
  sendCancelRequest,
  sendRevertCancelRequest,
  updateOrder,
  getApproveChanges,
  updateTaxiCorporation,
  updateExternalId,
  joinOrder,
  getFinishedCargoOrdersCount,
  getOrderFinishedUnbilledList,
  deleteForwarding,
  getTaxiAvailableConsumers,
  sendForwarding,
  getForwardingList,
  getAvailableDrivers,
  getActiveList,
  getFinishedList,
  getFinishedDownload,
  getAbandonedList,
  getAbandonedCargoOrderDownload,
  getDetailsComplex,
  getHandlingLog,
  getDetails,
  getCargoOrderHistory,
  getNodeExclusion,
  getDriverSimulation,
};

export default orderService;
